import _ from 'lodash';
import { isWidgetAiImageGenerating } from './aiImageEditGuard';

export const widgetListHasLoadingPlaceholder = (widgets) =>
  (widgets || []).some((w) => w.uid?.includes('widget_loading'));

export const widgetListHasAiImageEditing = (widgets) =>
  (widgets || []).some(isWidgetAiImageGenerating);

export const shouldSkipPresentOnUndoRedo = (widgets) =>
  widgetListHasLoadingPlaceholder(widgets) || widgetListHasAiImageEditing(widgets);

export const clearAiEditingFromWidgets = (widgets) =>
  (widgets || []).map((w) => {
    if (!isWidgetAiImageGenerating(w)) {
      return w;
    }
    const content = { ...w.content };
    delete content.aiEditing;
    return { ...w, content };
  });

export const isTransientAiEditingContentUpdate = (action, updateWidgetContentType) =>
  action.type === updateWidgetContentType &&
  _.get(action, 'payload.content.aiEditing') === true;
